import { Row, Col, Card } from "../../../../CommonComponents";
import "./AssetOrderDetailView.scss";
import LeadrOrder from "./LeadrOrder";
import AssetInformation from "./AssetInformation";
import AssetDispositionAndLocation from '../AssetDispositionAndLocation'
import { CONSTANTS } from "client/utils/constants";
import ReceivingBranchDetails from "../ReceivingBranchDetails";
import ApprovalHistoryTimeLineCommon from "client/CommonComponents/ApprovalHistoryTimeLineCommon";
import AFEOrderDetail from "./AFEOrderDetail";

const AssetOrderDetailView = (props: any) => {

  const {
    ordertype,
    afeOrderByIdData
  } = props

  return (
    <Row>
      <Col xs={12} md={12} lg={8} className="customerorderUI">
        <LeadrOrder ordertype = {ordertype}/>
        {props?.orderDetails?.transferDisposeReactivationDetails?.map((detailsByIdItem: any, detailsByIdIndex: number) => {
          if (detailsByIdItem?.orderRequestType !== CONSTANTS?.TRANSFER_REQUEST) {
            return <div className="mt-3 card-radius" key={detailsByIdIndex}>
              <Card data-attribute="AssetOrderDetailView_Default_Card">
                {(detailsByIdItem?.assets?.map((assetOrderByIdItem: any, assetOrderByIdIndex: number) =>
                  <AssetInformation assetOrderByIdItem={assetOrderByIdItem} assetOrderByIdIndex={assetOrderByIdIndex} detailsByIdIndex={detailsByIdIndex} detailsByIdItem={detailsByIdItem} globalPenaltyFlag={props?.orderDetails?.dispositionPenaltyFlag}/>
                ))}
              </Card>
            </div>
          }else if(detailsByIdItem?.orderRequestType === CONSTANTS?.TRANSFER_REQUEST){
            return <div className="mt-3" key={detailsByIdIndex}>
              <Card data-attribute="AssetOrderDetailView_Default_Card_2">
                <ReceivingBranchDetails
                  detailsByIdItem={detailsByIdItem}
                  orderDetails={props?.orderDetails}
                  detailsByIdIndex={detailsByIdIndex}
                  viewtype="orderdetail-view"
                />
              </Card>
            </div>
          }})}

        {props?.orderDetails?.transferDisposeReactivationDetails?.map((detailsByIdItem: any, detailsByIdIndex: number) => {
          if(detailsByIdItem?.orderRequestType == CONSTANTS?.DISPOSITION_REQUEST){
            return <AssetDispositionAndLocation detailsByIdItem={detailsByIdItem} viewtype="orderdetail-view" />
          }
        })}
        
{ordertype === CONSTANTS.AFEREQUEST && <AFEOrderDetail afeOrderByIdData={afeOrderByIdData} />}

      </Col>
      <Col xs={12} md={12} lg={4} className='mt-sm-0 mt-3'>
        <ApprovalHistoryTimeLineCommon isOrderDetail={true} approvalHistory={ordertype === CONSTANTS.AFEREQUEST ? afeOrderByIdData?.approvalHistory : props?.orderDetails?.approvalHistory}  data-attribute="AssetOrderDetailView_Default_ApprovalHistoryTimeLineCommon" />
      </Col>
    </Row>
  );
};

export default AssetOrderDetailView;
